<script lang="ts" setup>
import type { CatalogPageRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ cmsData: CatalogPageRecord }>();

const localePath = useLocalePath();
const route = useRoute();

const loginReturnUrl = computed(() => route.name?.toString().startsWith("auth-login") === false ? encodeURI(route.path) : undefined);
</script>

<template>
  <div class="p-lg gap-md relative flex flex-col rounded-lg bg-linear-to-b/srgb from-[#FFDE8F] to-[#FFB90A]">
    <h4>
      {{ cmsData.callToActionTitle }}
    </h4>

    <div class="[&_li]:before:content-check [&_li]:before:me-xs [&_li]:py-2xs" v-html="cmsData.callToActionText" />

    <div class="gap-x-sm flex flex-col xl:flex-row">
      <UButton variant="solid" color="primary" size="md" :to="localePath(`/${cmsData.callToActionRegistrationButtonLink.slug}`)">
        {{ cmsData.callToActionRegistrationButtonText }}
      </UButton>

      <UButton
        variant="link" color="neutral" size="md" class="underline"
        :to="localePath({ name: 'auth-login', query: { returnUrl: loginReturnUrl } })"
      >
        {{ cmsData.callToActionLoginButtonText }}
      </UButton>
    </div>

    <Vector class="vector--background absolute bottom-[-60%] left-[-20%] h-auto w-[200px]" />
  </div>
</template>

<style scoped>
.vector--background {
  --esc-vector-fill-color: var(--color-neutral-100);
  --esc-vector-mix-blend-mode: soft-light;
  --esc-vector-opacity: 0.3;
}
</style>
